import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Edit } from "lucide-react";

export const EditInvoiceModal = ({
  open,
  onOpenChange,
  editInvoice,
  setEditInvoice,
  onSaveEdit
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Edit className="h-5 w-5 text-primary" />
            Edit Invoice
          </DialogTitle>
        </DialogHeader>
        {editInvoice && (
          <div className="space-y-4 py-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Subtotal ($)</Label>
                <Input
                  type="number"
                  step="0.01"
                  value={editInvoice.subtotal}
                  onChange={(e) => setEditInvoice(prev => ({ ...prev, subtotal: e.target.value }))}
                  className="bg-secondary/50 border-black/10"
                />
              </div>
              <div className="space-y-2">
                <Label>Discount (%)</Label>
                <Input
                  type="number"
                  step="0.1"
                  value={editInvoice.discount_percentage}
                  onChange={(e) => setEditInvoice(prev => ({ ...prev, discount_percentage: e.target.value }))}
                  className="bg-secondary/50 border-black/10"
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <Label>Final Total ($)</Label>
              <Input
                type="number"
                step="0.01"
                value={editInvoice.total}
                onChange={(e) => setEditInvoice(prev => ({ ...prev, total: e.target.value }))}
                className="bg-secondary/50 border-black/10"
              />
              <p className="text-xs text-muted-foreground">Override the calculated total if needed</p>
            </div>
            
            <div className="space-y-2">
              <Label>Due Date</Label>
              <Input
                type="date"
                value={editInvoice.due_date}
                onChange={(e) => setEditInvoice(prev => ({ ...prev, due_date: e.target.value }))}
                className="bg-secondary/50 border-black/10"
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Billing Period From</Label>
                <Input
                  type="date"
                  value={editInvoice.billing_period_from}
                  onChange={(e) => setEditInvoice(prev => ({ ...prev, billing_period_from: e.target.value }))}
                  className="bg-secondary/50 border-black/10"
                />
              </div>
              <div className="space-y-2">
                <Label>Billing Period To</Label>
                <Input
                  type="date"
                  value={editInvoice.billing_period_to}
                  onChange={(e) => setEditInvoice(prev => ({ ...prev, billing_period_to: e.target.value }))}
                  className="bg-secondary/50 border-black/10"
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <Label>Notes</Label>
              <Input
                value={editInvoice.notes}
                onChange={(e) => setEditInvoice(prev => ({ ...prev, notes: e.target.value }))}
                placeholder="Invoice notes"
                className="bg-secondary/50 border-black/10"
              />
            </div>
            
            <div className="space-y-2">
              <Label>Reason for Revision</Label>
              <Input
                value={editInvoice.adjustment_reason}
                onChange={(e) => setEditInvoice(prev => ({ ...prev, adjustment_reason: e.target.value }))}
                placeholder="e.g., Price adjustment, Additional services"
                className="bg-secondary/50 border-black/10"
              />
            </div>
            
            <div className="flex justify-end gap-2 pt-4">
              <Button variant="outline" onClick={() => onOpenChange(false)}>
                Cancel
              </Button>
              <Button onClick={onSaveEdit}>
                Save Changes
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
